import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutIdleTrailerReport } from "./autogen/AutogenLayoutIdleTrailerReport";

export class IdleTrailerReport extends AutogenLayoutIdleTrailerReport {
    override onLoad(): void | Promise<void> {
        this.textboxStatus.selectedItem = this.textboxStatus.items[1];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxStateZoneSearch.enabled = false;
    }

    excludabletextboxFleetTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_trailer = "Y"
    }

    private onChangeStateZoneLocation() {
        this.textboxStateZoneSearch.clear();
        const isTextEmptyOrWildcard = (this.textboxStateZoneLocation.text == "=" || this.textboxStateZoneLocation.text.length < 1);
        if (isTextEmptyOrWildcard) this.textboxStateZoneSearch.clear();
        this.textboxStateZoneSearch.enabled = !isTextEmptyOrWildcard;
        const inputData = this.textboxStateZoneLocation.text;
        this.setupStateZoneLocationLookup(inputData);
    }

    private setupStateZoneLocationLookup(selectedItem: string) {
        switch (selectedItem) {
            case "State": {
                this.textboxStateZoneSearch.lookupModel = "common/states";
                this.textboxStateZoneSearch.lookupModelLayout = "common/States";
                this.textboxStateZoneSearch.lookupModelDisplayField = "name";
                this.textboxStateZoneSearch.lookupModelResultField = "id";
                this.textboxStateZoneSearch.lookupModelAllowMultiSelect = true;
                break;
            }
            case "Zone": {
                this.textboxStateZoneSearch.lookupModel = "lme/general/zones";
                this.textboxStateZoneSearch.lookupModelLayout = "lme/dispatch/planning/OrderZones";
                this.textboxStateZoneSearch.lookupModelDisplayField = "descr";
                this.textboxStateZoneSearch.lookupModelResultField = "id";
                this.textboxStateZoneSearch.lookupModelAllowMultiSelect = true;
                break;
            }
            case "Location": {
                this.textboxStateZoneSearch.lookupModel = "lme/dispatch/location";
                this.textboxStateZoneSearch.lookupModelLayout = "lme/dispatch/LocationLookup";
                this.textboxStateZoneSearch.lookupModelDisplayField = "name";
                this.textboxStateZoneSearch.lookupModelResultField = "id";
                this.textboxStateZoneSearch.lookupModelAllowMultiSelect = true;
                break;
            }
        }
    }
}
